import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=7fe8f5d5&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe8f5d5')) {
      api.createRecord('7fe8f5d5', component.options)
    } else {
      api.reload('7fe8f5d5', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=7fe8f5d5&", function () {
      api.rerender('7fe8f5d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DWSnXmS2WFG3/JS/videoIframe.vue"
export default component.exports